import { Button } from "@win-reality/react-ui";
import { useState } from "react";

import { GameTeam } from "@/types/game";

import { TeamOption, TeamRosterPicker } from "../Overview/TeamRosterPicker";

export type SelectTeamSelection = {
  teamUuid: string;
  teamName: string;
  visibilityGroup: string;
  parentName?: string | null;
};

type TeamPanelProps = {
  side: TTeamSides;
  team?: GameTeam;
  onSelectTeam: (selection: SelectTeamSelection) => void;
};

export const TeamPanel = ({ side, team, onSelectTeam }: TeamPanelProps) => {
  const label = side === "away" ? "AWAY" : "HOME";
  const pickerLabel = side === "away" ? "Away Team" : "Home Team";

  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleConfirm = (
    option: TeamOption | null,
    visibilityGroup: string,
  ) => {
    if (!option) return;
    onSelectTeam({
      teamUuid: option.value,
      teamName: option.label,
      visibilityGroup,
      parentName: option.meta?.parentName ?? null,
    });
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center max-h-[calc(100dvh-14rem)] my-8">
      <h2 className="text-xl font-regular tracking-wide text-text-light">
        {label}
      </h2>

      <TeamRosterPicker
        label={pickerLabel}
        value={team?.uuid ?? null}
        initialLabel={team?.name}
        isOpen={isPickerOpen}
        onOpenChange={setIsPickerOpen}
        onConfirm={handleConfirm}
      />

      <Button
        variant="secondary-flat-light"
        size="default"
        onClick={() => setIsPickerOpen(true)}
        className="min-w-50 rounded-full mt-6"
      >
        Select Team Roster
      </Button>
    </div>
  );
};
